import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrganizationFeaturesDto } from '../entities/organization-features-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class OrganizationFeaturesApiService extends ParentApiService {
  private readonly url = `${environment.webApiAddress}/api/my-organization/features`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getFeatures(stayOnPageIfError?: boolean): Observable<OrganizationFeaturesDto> {
    return this.http.get<OrganizationFeaturesDto>(this.url, { headers: this.headersFor(stayOnPageIfError) });
  }
}
